import { Routes } from '@angular/router';
import { ShipmentComponent } from './shipment.component';
import { CreateShipmentComponent } from './create-shipment/create-shipment.component';
import { ViewShipmentComponent } from './view-shipment/view-shipment.component';
import { DeliveryComponent } from './delivery/delivery.component';
import { DeliverySiteOperationComponent } from './delivery/site-operation/delivery-site-operation.component';
import { ShipmentCompanyComponent } from './company/shipment-company.component';
import { DeliveryCompanyComponent } from './company/delivery-company/delivery-company.component';
import { GenerateDeliveriesComponent } from './delivery/generate-deliveries/generate-deliveries.component';
import { PermissionGuard } from '../security/permission.guard';
import { ShipmentEditDisabledGuard } from './shipment-edit-disabled.guard';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { ShipmentDashboardComponent } from './dashboard/shipment-dashboard.component';
import { app_permissions } from '../security/app-permissions';
import { ShipmentBulkUploadComponent } from './bulk-upload/shipment-bulk-upload.component';
import { DeliveryRateCardsComponent } from './rate-cards/delivery-rate-cards.component';
import { InternalTransportCostsComponent } from './internal-transport-costs/internal-transport-costs.component';
import { SimpleShipmentViewComponent } from './simple-operations/simple-shipment-view.component';
import { ExpressShipmentComponent } from './express/express-shipment.component';

export const shipmentRoutes: Routes = [
    {
        path: 'shipment',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: { enterpriseModules: ['SHIPMENTS'], enterpriseFeatureLabel: 'Shipments' },
        children: [
            {
                path: 'dashboard',
                component: ShipmentDashboardComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.dashboard.view, scope: 'ANY' }
            },
            {
                path: '',
                component: ShipmentComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.view }
            },
            {
                path: 'company',
                component: ShipmentCompanyComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.view }
            },
            {
                path: 'deliveries',
                component: DeliveryCompanyComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.deliveries.view }
            },
            {
                path: 'create',
                component: CreateShipmentComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.CREATE }
            },
            {
                path: 'create/advanced',
                redirectTo: 'create',
                pathMatch: 'full'
            },
            {
                path: 'create/simple',
                redirectTo: 'create/express',
                pathMatch: 'full'
            },
            {
                path: 'create/express',
                component: ExpressShipmentComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.CREATE }
            },
            {
                path: 'bulk-upload',
                component: ShipmentBulkUploadComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.import }
            },
            {
                path: 'rate-cards',
                component: DeliveryRateCardsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.contracts.rate_cards.view }
            },
            {
                path: 'internal-transport-costs',
                component: InternalTransportCostsComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.internal_transport_costs.view }
            },
            {
                path: 'edit/:shipmentId',
                component: ViewShipmentComponent,
                canActivate: [ShipmentEditDisabledGuard]
            },
            {
                path: 'view/:shipmentId',
                component: ViewShipmentComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.view }
            },
            {
                path: 'view/:shipmentId/advanced',
                redirectTo: 'view/:shipmentId',
                pathMatch: 'full'
            },
            {
                path: 'view/:shipmentId/simple',
                component: SimpleShipmentViewComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.view }
            },
            {
                path: 'delivery/view/:deliveryId', // Direct child of 'order' route
                component: DeliveryComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.deliveries.view }
            },
            {
                path: 'delivery/view/:deliveryId/site/:stopId',
                component: DeliverySiteOperationComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.deliveries.site_operations }
            },
            {
                path: 'delivery/:shipmentId/generate', // Direct child of 'order' route
                component: GenerateDeliveriesComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.shipments.deliveries.GENERATE }
            }
        ]
    },
];


